import { TickerStateType } from 'data/Ticker/reducers'
import { TicketFormType } from 'data/types'

import { Book, OrderBookEntryType, SideType, TopOfBookType } from './types'

export type MarketBest = {
  ask: OrderBookEntryType
  bid: OrderBookEntryType
}
export const getBest = (market: Book): MarketBest => {
  const bestAsk = market.asks.get(Math.min(...market.asks.keys()))!
  const bestBid = market.bids.get(Math.max(...market.bids.keys()))!
  return { ask: bestAsk, bid: bestBid }
}

export const getMidPrice = (market: Book): number => {
  const best = getBest(market)
  if (!best.ask || !best.bid) return 0
  return (best.ask.px + best.bid.px) / 2
}

const getPriceFallback = (tickerData, symbol) => {
  if (!tickerData[symbol]) return 0
  return tickerData[symbol].price_24h || tickerData[symbol].last_trade_price
}

const getMarketPrice = (side: 'buy' | 'sell', best: TopOfBookType) =>
  side === 'buy' ? best.ask?.px : best.bid?.px

export const getPlaceholderPrice = (
  tickerData: TickerStateType,
  symbol: string,
  formValues: TicketFormType,
  best: TopOfBookType
) => {
  const fallback = getPriceFallback(tickerData, symbol)
  const marketPrice = getMarketPrice(formValues.side, best)

  switch (formValues.type) {
    case 'stopLimit':
      return formValues.limitPrice ?? marketPrice ?? fallback
    case 'stop':
      return formValues.triggerPrice ?? fallback
    case 'market':
      return marketPrice ?? fallback
    default:
      return formValues.limitPrice ?? marketPrice ?? fallback
  }
}

export const getOppositeSide = (side: SideType) => (side === 'buy' ? 'sell' : 'buy')
